// authService.js
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import app from '../firebaseConfig.js';
import { signInRequest, signInSuccess, signInFailure, signOutSuccess, setAuthDetails } from '../redux/authSlice.js';

const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Sign-In Function
export const signIn = () => async (dispatch) => {
  dispatch(signInRequest());
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const userData = {
      uid: user.uid,
      displayName: user.displayName,
      email: user.email,
      photoURL: user.photoURL,
    };

    dispatch(signInSuccess(userData));
    dispatch(setAuthDetails(userData));
  } catch (error) {
    dispatch(signInFailure(error.message));
  }
};

// Sign-Out Function
export const signOutUser = () => async (dispatch) => {
  try {
    await signOut(auth);
    dispatch(signOutSuccess());
    dispatch(setAuthDetails(null)); 
  } catch (error) {
    console.error("Sign out error:", error.message);
  }
};


export const getAuthDetails = () => (dispatch) => {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      const userData = {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
      };
      dispatch(setAuthDetails(userData));
      return userData;
    } else {
      dispatch(setAuthDetails(null)); 
    }
  });
};
